const createPassword = {
  en: {
    password: "password",
    title: "Create new password",
    PasswordLabel: "New Password",
    PasswordConfirmationLabel: "Confirm Password",
    PasswordPlaceholder: "Enter your new password",
    PasswordConfirmationPlaceholder: "Enter your new password",
    cancel: "Cancel",
    successTitle: "Your password was successfuly changed",
    successText:
      "Congratulations, your new password was set and you can access the system by using it on the login screen",
    confirmPasswordNotMatch: "Passwords do not match"
  },
  pt: {
    password: "senha",
    title: "Criar nova senha",
    PasswordLabel: "Nova senha",
    PasswordConfirmationLabel: "Confirmar senha",
    PasswordPlaceholder: "Digite sua nova senha",
    PasswordConfirmationPlaceholder: "Digite a confirmação de senha",
    cancel: "Cancelar",
    successTitle: "Sua senha foi alterada com sucesso",
    successText:
      "Parabéns, sua nova senha foi criada com sucesso agora você já pode acessar o sistema usando ela para fazer o login",
    confirmPasswordNotMatch: "As senhas não conferem"
  },
  es: {
    password: "contraseña",
    title: "Crear nueva contraseña",
    passwordLabel: "Nueva contraseña",
    PasswordConfirmationLabel: "Confirmar contraseña",
    PasswordPlaceholder: "Introduzca su nueva contraseña",
    PasswordConfirmationPlaceholder: "Introduzca su nueva contraseña",
    cancel: "Cancelar",
    successTitle: "Su contraseña ha sido cambiada con éxito",
    successText:
      "Enhorabuena, su nueva contraseña ha sido creada con éxito ahora puede acceder al sistema utilizándola para iniciar sesión",
    confirmPasswordNotMatch: "Las contraseñas no coinciden"
  }
}

export default createPassword
